import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SortingEnum } from '../../locations-skeleton/enums/sorting-enum';
import { NgClass } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-column-sorting-button',
    templateUrl: './column-sorting-button.component.html',
    styleUrls: ['./column-sorting-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatButton, NgClass]
})
export class ColumnSortingButtonComponent {

  @Input() columnName: string;

  @Input() sortDirection: SortingEnum = SortingEnum.NONE;
  @Input() sortIndex: number;
  @Input() sortingDisabled: boolean = false; // removes the possibility to sort this column (disables button)

  @Output() sortingChange: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  // for use in HTML
  SortingEnum = SortingEnum;

  constructor() {
  }

}
